import { Component, OnInit, Inject, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectSaleCustomFilter, ProjectSaleInfo } from '../model/projectsale.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { GlobalService } from '../service/global.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,

  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';
import { Router } from '@angular/router';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { StateInfo } from '../model/StateInfo.model';

@Component({
  selector: 'app-effort-management',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './effort-management.component.html',
  styleUrls: ['./effort-management.component.css']
})
export class EffortManagementComponent implements OnInit {

  form: FormGroup;

  public body: string;
  ProjectSaleListPromise: Promise<ProjectSaleInfo[]>
  ProjectSaleList: ProjectSaleInfo[] = []
  ProjectSaleListPromisereturn: Promise<ProjectSaleInfo[]>[]
  CompanyList: CompanyInfo[] = []
  CategoryList: LookupInfo[] = []

  // array control
  itemsSupport: FormArray;


  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number

  public empcodeinit: string
  _EmpCode: string;
  _RoleCode: string;
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;

  public currentPageNumberEmp: number
  public totalPagesEmp: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean = false;
  isViewOnly: boolean = false;
  isSubmitted: any;

  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number

  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;

  baseurl: string;
  expense_baseurl: string;

  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[];
  today: string;


  //Search Conditions
  ListLead: ProjectSaleInfo[] = [];
  ListCompany: CompanyInfo[] = [];

  txtSchLead: string = "";
  txtSchCompany: string = "";

  leadselectrun: boolean = false;
  companyselectrun: boolean = false;
  selectedlead: ProjectSaleInfo[] = [];
  selectedcompany: CompanyInfo[] = [];

  isSearchSubmitted: boolean = false;

  titlemodal: string;
  detailmodal: string;
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router) {
    this.baseurl = environment.base_api;
    this.expense_baseurl = environment.expense_base_api;
    GlobalService.CheckPagingAccessRights();

  }

  async ngOnInit() {
    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSizeSmall;

    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");
    this.currentPageNumberEmp = 1;

    this.form = this.formBuilder.group({
      ProjectSaleCodeSearch: [null],
      ProjectSaleNameSearch: [null],
      ProjectSaleCompanyIdSearch: [null],
    });

    this.LoadProjectSale();
  }

  btnClick_SearchProjectSaleList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;

    this.isSearchSubmitted = true;
    
    this.ListLead = this.selectedlead;
    this.ListCompany = this.selectedcompany;

    this.LoadProjectSale()
  }

  ClearSearch() {
    this.form.patchValue({
      ProjectSaleCodeSearch: "",
      ProjectSaleNameSearch: "",
      ProjectSaleCompanyIdSearch: "",
    });
    this.currentPageNumber = 1;
    this.indexNo = 0;

    this.selectedlead = [];
    this.selectedcompany = [];

    this.LoadProjectSale();
  }

  async LoadProjectSale(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleList(auth_token);
      this.LoadProjectSaleCountList(auth_token);
    }
  }

  LoadProjectSaleList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumber - 1) * this.environment;
    
    var objectjson = {};
    //objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    //objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;

    objectjson['rowFetch'] = this.environment;
    objectjson['rowOFFSet'] = offset;
    //objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";
    objectjson['ProjectSaleFlagOrderbyAssign'] = "Y";

    this.ListCompany = this.selectedcompany;
    this.ListLead = this.selectedlead;

    let x = new ProjectSaleCustomFilter();
    x.ProjectSaleEffortEstimation = true;
    x.listLead = this.ListLead;
    x.listCompany = this.ListCompany;
    objectjson['ProjectSaleCustomFilter'] = x;

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      .subscribe({
        next: (data) => {
          this.ProjectSaleList = data;

        }
      });


  }

  LoadProjectSaleCountList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };


    var objectjson = {};
    //objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    //objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;

    //objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";

    this.ListCompany = this.selectedcompany;
    this.ListLead = this.selectedlead;

    let x = new ProjectSaleCustomFilter();
    x.ProjectSaleEffortEstimation = true;
    x.listLead = this.ListLead;
    x.listCompany = this.ListCompany;
    objectjson['ProjectSaleCustomFilter'] = x;

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<number>(this.baseurl + "ProjectSale/GetCountProjectSale", strjson, httpOptions)
      .toPromise().then((data) => {


        this.hidcouchk = data;
        if (this.hidcouchk == 0) {
          this.currentPageNumber = 0;
          this.totalPages = 0;
        } else {
          this.totalPages = Math.ceil(this.hidcouchk / this.environment);
        }
      })


  }


  async LoadProjectSaleAll(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    //objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    //objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;

    objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";

    this.ListCompany = this.selectedcompany;
    this.ListLead = this.selectedlead;

    let x = new ProjectSaleCustomFilter();
    x.ProjectSaleEffortEstimation = true;
    x.listLead = this.ListLead;
    x.listCompany = this.ListCompany;
    objectjson['ProjectSaleCustomFilter'] = x;

    if (this.viewflag == true) {

    }
    else {
      objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    }

    let strjson = JSON.stringify(objectjson);


    this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      .toPromise().then((data) => {
        this.countall = data.length;

      })


  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }



  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {

    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  //For Pagination
  async OnPaginationLoaded(traget) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumberEmp = traget.currentPageNumber;
      this.totalPagesEmp = traget.totalPages;
    }

    //var auth_token = await this.TokenService.RefreshToken();
    //if (!!auth_token) {

    //  this.LoadEmpforAssign(auth_token);
    //}
  }



  // effort code
  lead_select() {
    this.leadselectrun = true;
    this.form.patchValue({
      ProjectSaleCodeSearch: "",
    });
    this.selectedlead = [];
    $('#ModalLeadSelect').modal();
  }

  company_select() {
    this.companyselectrun = true;
    this.form.patchValue({
      ProjectSaleCompanyIdSearch: "",
    });
    this.selectedcompany = [];
    $('#ModalCompanySelect').modal();
  }

  selectedLead(event) {
    this.selectedlead = event;
    this.saveLeadSelect();
  }
  selectedCompany(event) {
    this.selectedcompany = event;
    this.saveCompanySelect();
  }

  async saveLeadSelect() {

    $('#ModalLeadSelect').modal('hide');
    this.leadselectrun = false;

    //this.form.controls['ProjectSaleCodeSearch'].setValue(this.selectedlead.length + ' lead(s) selected')
    this.form.controls['ProjectSaleCodeSearch'].setValue(this.selectedlead[0].ProjectSaleCode)
  }
  async saveCompanySelect() {

    $('#ModalCompanySelect').modal('hide');
    this.companyselectrun = false;

    //this.form.controls['ProjectSaleCompanyIdSearch'].setValue(this.selectedcompany.length + ' company(s) selected')
    this.form.controls['ProjectSaleCompanyIdSearch'].setValue(this.selectedcompany[0].CompanyCode)
  }

}


